// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5673":"35fef7c60ca8289a","6272":"aa4472f7082b94cd","7584":"a5f0c83ca3a862b0","9854":"499d4f2e8b9a6aa1"}[chunkId] + ".css";
};